// Demo / How it Works Section - Visual demonstration with benefit-focused caption
const Demo = () => {
    return (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 bg-gray-50">
            {/* Section Header */}
            <div className="text-center mb-16">
                <h2 className="text-4xl sm:text-4xl font-semibold text-gray-900 mb-4">
                    See it in action
                </h2>
                <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                    Watch how Sentivo transforms your search workflow. Find everything in seconds, 
                    without breaking your flow.
                </p>
            </div>

            {/* Demo Video */}
            <div className="max-w-5xl mx-auto mb-12">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-gray-200 bg-white p-2">
                    <video 
                        src="/demo.mov" 
                        autoPlay 
                        loop 
                        muted 
                        playsInline 
                        className="w-full rounded-xl"
                    />
                </div>
            </div>

            {/* Benefit Caption */}
            <div className="text-center max-w-3xl mx-auto">
                <h3 className="text-2xl sm:text-3xl font-semibold text-gray-900 mb-4">
                    Unified search. Instant results. Your workflow, uninterrupted.
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                    Stop wasting time digging through folders or cloud drives. Search all your files, 
                    documents, and notes from one single bar. Built for Mac, designed for speed.
                </p>
            </div>
        </section>
    )
}

export default Demo